import React, { useState } from "react";
import UserDrawer from "../../components/drawer/UserDrawer";
import { Row, Col } from "antd";
import BotEnvironment from "../botEnvironment/BotEnvironment";
import myFriendText from "../../assets/images/my_friend_text.svg";
import goBackButton from "../../assets/images/Go_Back.svg";
import searchButton from "../../assets/images/Search Icon.svg";
import "../onboarding/UserOnboardingPage.css";
import { useNavigate } from "react-router-dom";


function ChatBotPage() {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const navigate = useNavigate();

  const openDrawer = () => {
    setIsDrawerOpen(true);
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false);
  };

  const contentWrapperStyle = {
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    transition: "margin-right 0.3s ease",
    paddingBottom: "40px",
  };

  function handleGoBackButton() {
    navigate("/landing-page");
  }

  return (
    <>
      <div>
        <Row className="onboarding-page-section">
          <Col flex="10%" className="go-back-button">
            <button onClick={handleGoBackButton} className="button-styling">
              <img src={goBackButton} alt="Go Back Button" />
            </button>
          </Col>
          <Col flex="80%" className="my-friend-text">
            <img src={myFriendText} alt="My Friend Text" />
          </Col>
          <Col flex="10%" className="search-button">
            <button className="button-styling">
              <img src={searchButton} alt="Search Button" />
            </button>
          </Col>
        </Row>
        <Row justify={"center"}>
          <Col span={22}>
            <div style={contentWrapperStyle} className="content-wrapper">
              <BotEnvironment isDrawerOpen={isDrawerOpen} />
            </div>
          </Col>
          {isDrawerOpen && (
            <Col span={4}>
              <UserDrawer isDrawerOpen={isDrawerOpen} onClose={closeDrawer} />
            </Col>
          )}
        </Row>
      </div>
    </>
  );
}

export default ChatBotPage;